import {
  Avatar,
  Button,
  Drawer,
  Form,
  Image,
  Input,
  message,
  Modal,
  Popover,
  Select,
  Skeleton,
  Space,
  Tabs,
  Typography
} from "antd";
import SOCIAL_SHARING from "../../../components/libs/readyToUse/socialNetworks";

import React, { FC, Fragment, useCallback, useEffect, useRef, useState } from "react";
// import { RoomCard } from '../dashboard'
import * as ROOMS_SERVICES from "api/services/rooms/rooms.services";
import { calculateTimeDifference, isToday, StatusCode } from "common/enums";
import Breadcrumbs from "components/breadcrumbs";
import AppButton from "components/libs/button";
import * as appRoutes from "config/routes.config";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as TOPICS_SERVICES from "../../../api/services/topics/topics.services";
import st from "../Calendar/assets/calendar.module.css";
import AppScreen from "../ScreenWithSidebar";
import stl from "./assets/myClasses.module.css";
import { default as s, default as styles } from "./style.module.css";

// !COPYtoCLIP-BOARD
import { CopyToClipboard } from "react-copy-to-clipboard";
//!IMAGES
import AppResult from "components/appResults";
import Flex from "components/libs/flex";
import CardClasses from "screens/teacher/components/cardClasses";
import { useGetAdHistoriqueQuery } from "store/services/teacher/ads.services";
import { useGetOrganismRoomsQuery, useGetRoomsQuery, useGetTeacherReservationsQuery, useGetTeacherRoomsQuery } from "store/services/teacher/classes.services";
import ArrowBack from "../../../assets/images/app/arrow_back.svg";
import Camera from "../../../assets/images/app/camera.svg";
import ClockIcon from "../../../assets/images/app/clock_icon.svg";
import Close from "../../../assets/images/app/close.svg";
import EllipseTeacherProfileFour from "../../../assets/images/app/ellipse_teacher_profile4.png";
import EllipseTeacherProfileFive from "../../../assets/images/app/ellipse_teacher_profile5.png";
import students from "../../../assets/images/app/iam_student.svg";
import Success from "../../../assets/images/teacher/success.svg";
import Key from "./assets/key.svg";

import { TeacherJoinOrganismClass } from "api/services/teacher/teacher.services";
import AppDrawer from "components/appDrawer";
import { AppNotification } from "components/appNotification";
import HelpPopover from "components/help";
import H1 from "components/libs/title";
import { Field, Formik, Form as FormikForm } from "formik";
import { setCheckClass, setCheckClassOrganism } from "store/app/appSlice";
import { TeacherJoinClassSchema } from "validations";
import CLassroomIcon from "../../../assets/images/icons/teacher_classes.svg";
import Matiers from "../../../components/matiers";
import AddRoom from "../components/addRoom";

interface CoursesRoomProps {
  course?: object | any;
}

const CoursesRoom: FC<CoursesRoomProps> = ({ course }) => {

  const auth = useSelector((state) => state.auth);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  return (
    <div className={st.classeCard} style={{ cursor: "pointer" }}>
      <div className={st.cardClassBox}>
        <div className={st.avatarNameBox}>
          <Avatar.Group
            maxCount={3}
            maxStyle={{
              color: "#f56a00",
              backgroundColor: "#fde3cf",
            }}
            style={{ marginRight: isMobile ? "0px" : "7px" }}
          >
            <Avatar
              size={45}
              style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029" }}
              src={course?.typeCreneaux === "collectif" ? students : course?.studId?.profile}
            />
          </Avatar.Group>
          <div style={{ fontSize: isMobile ? "1em" : "13px", display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
            {course?.typeCreneaux === "collectif" ? "Cours Collectif" : course?.studId?.firstname + " " + course?.studId?.lastname}
          </div>
        </div>
        {isMobile && course?.typeCreneaux !== "collectif" && !course?.isCollective && <Matiers
          cours={course?.topic?.title || "null"}
          level={course?.level?.title || "null"}
        />}
        <div className={st.detailsBox}>
          <div className={st.timeBox}>
            {!isMobile && <img src={ClockIcon} height={15} style={{ marginRight: "10px" }}></img>}
            <div className={st.times}>
              <span className={st.time}>{isMobile && <img src={ClockIcon} height={10} style={{ marginRight: "5px" }}></img>} De {course?.range[0]} à {course?.range[course?.range?.length - 1]}</span>
              <span className={st.timeDescription}>Séance de “{calculateTimeDifference(course?.range[0], course?.range[course?.range.length - 1])}”</span>
            </div>
          </div>
          {!isMobile && course?.typeCreneaux !== "collectif" && !course?.isCollective && <div style={{ width: "32%" }}>
            <Matiers
              cours={course?.topic?.title || "null"}
              level={course?.level?.title || "null"}
            />
          </div>}
          <div className={st.amountBox}>
            Séance réservée pour
            {course?.typeCreneaux !== "collectif" && <div className={st.priceBox}>{(course?.byCredits === "oui" || course?.byCredits === "true") ? course?.creditedValue + " Crédit" : course?.price + " €"}</div>}
            {course?.typeCreneaux === "collectif" && <div className={st.priceBox}>{course?.pricePerStudent ? course?.pricePerStudent + " Crédit" : course?.price + " Crédit"}</div>}
          </div>
        </div>

        {course?.status !== "SUCCESS" && course?.typeCreneaux !== "collectif" && <a href={course?.profLink} target="_blank">
          <Button className={s.meetButton} icon={<img src={Camera} height={10} style={{ marginRight: "10px" }} />}>
            Lien vidéoconf
          </Button>
        </a>}
        {course?.status !== "SUCCESS" && course?.typeCreneaux === "collectif" && <a href={course?.commonLink} target="_blank">
          <Button className={s.meetButton} icon={<img src={Camera} height={10} style={{ marginRight: "10px" }} />}>
            Lien vidéoconf
          </Button>
        </a>}
      </div>
    </div>
  );
};

const { TabPane } = Tabs;

const { Title } = Typography;
const { Option } = Select;
const { Search } = Input;
const MESSAGE_PREFIX_PARTAGE_RESEAUX_SOCIAUX = "Bonjour ! Rejoins ma classe sur Monamilabert.com en utilisant ce code :";

const Rooms: FC = () => {
  //!HOOKS
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { userHavingCalendar, userTeachingOrganismClass } = useSelector((state) => state.app);
  const [addCourseForm] = Form.useForm();
  const topics = useSelector((state) => state.topics);
  const levels = useSelector((state) => state.levels);
  const { data, isLoading, isError } = useGetTeacherReservationsQuery(auth?.user?._id);
  const {
    data: adHistorique,
    isLoading: adHistoriqueLoading,
    isError: adHistoriqueisError,
  } = useGetAdHistoriqueQuery(auth?.user?._id);

  const [form] = Form.useForm();
  const [values, setValues] = useState<any>({});
  const submit = useRef<any>(null);
  const [isloadingTopic, setIsloadingTopic] = useState<boolean>(false);


  //!STATE
  const [showAddCourseModal, setShowAddCourseModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [coursesError, setCoursesError] = useState("");
  const [isDataLoading, setIsDataLoading] = useState<boolean>(false);

  const { data: rooms, isLoading: loadingRooms, refetch } = useGetRoomsQuery(auth?.user?._id);
  const { data: organismRooms, isLoading: loadingOrganismRooms, refetch: refetchOrganismRooms } = useGetOrganismRoomsQuery(auth?.user?._id);
  const { data: roomsData, isLoading: loadingRoomsData, refetch: refetchRooms } = useGetTeacherRoomsQuery(auth?.user?._id);

  const [addCourseLoading, setAddCourseLoading] = useState(false);
  const [addCourseError, setAddCourseError] = useState("");
  const [showAddClasse, setShowAddClasse] = useState(false);
  const [isModalSuccessAddCours, setIsModalSuccessAddCours] =
    useState<boolean>(false);
  const [tempRoom, setTempRoom] = useState<any>(null);
  const [tempTopic, setTempTopic] = useState<any>();
  const [visibleSocialMedia, setVisibleSocialMedia] = useState(false);
  const { checkClass, checkClassOrganism } = useSelector((state) => state.app);

  const [code, setCode] = useState(null);
  const [organismToken, setOrganismToken] = useState<any>("");
  const [organismClassCode, setOrganismClassCode] = useState<any>("");
  const [organismClassDrawer, setOrganismClassDrawer] = useState<boolean>(false);


  const [currentTab, setCurrentTab] = useState<any>("1");
  const [courses, setCourses] = useState<any>([]);
  const [coursesHistory, setCoursesHistory] = useState<any>([]);

  const [filterClasses, setFilterClasses] = useState<any>();
  const [filteredClasses, setFilteredClasses] = useState<any>();

  //!FUNCTIONS
  const handleAddCourseOk = () => setShowAddCourseModal(true);
  const openAddCourseModal = () => setShowAddCourseModal(true);
  const goToTeacherRooms = () => navigate(appRoutes.TEACHER_ROOMS);
  const closeAddCourseModal = () => setShowAddCourseModal(false);
  const handleVisibleChange = () => setVisibleSocialMedia(!visibleSocialMedia);
  const showOrganismClassDrawer = () => setOrganismClassDrawer(true);

  const onCloseOrganismClassDrawer = () => {
    setOrganismClassDrawer(false);
    localStorage.setItem("organismClassCode", "");
    localStorage.setItem("organismToken", "");
    localStorage.setItem("userType", "");
  };

  const addCourse = useCallback(
    async (course: any) => {
      try {
        setAddCourseLoading(true);
        setAddCourseError("");

        const final = {
          ...course,
          teacherId: auth.user?._id,
        };

        const response = await ROOMS_SERVICES.createRoom(final);
        console.log(response?.data);
        if (response?.statusCode === StatusCode.CREATED) {
          setTempRoom(response?.data);
          setShowAddCourseModal(false);
          refetch();
          message.success("créé avec succès !");
          addCourseForm.resetFields();
          setShowAddClasse(false);
          setTimeout(() => {
            setIsModalSuccessAddCours(true);
            setCode(response.data);
          }, 1500);
        } else {
          setAddCourseError(response?.message || "Erreur serveur");
        }
      } catch (error: any) {
        setAddCourseError(error?.message || "error");
        message.error(error?.message || "error");
      } finally {
        setAddCourseLoading(false);
      }
    },
    [addCourseForm]
  );

  const addOpenClass = async (values: any) => {
    try {
      setAddCourseLoading(true);
      setAddCourseError("");

      const roomData = {
        title: values?.className,
        isCollective: true,
        classType: "OPEN",
        teacherId: auth?.user?._id
      };

      const response = await ROOMS_SERVICES.createOpenRoom(roomData);
      if (response?.statusCode === StatusCode.CREATED) {
        setTempRoom(response?.data);
        setShowAddCourseModal(false);
        refetchRooms();
        message.success("créé avec succès !");
        addCourseForm.resetFields();
        setShowAddClasse(false);
        setTimeout(() => {
          setIsModalSuccessAddCours(true);
          setCode(response.data);
        }, 1500);
      } else {
        setAddCourseError(response?.message || "Erreur serveur");
      }
    } catch (error: any) {
      setAddCourseError(error?.message || "error");
      message.error(error?.message || "error");
    } finally {
      setAddCourseLoading(false);
    }
  };

  const addPackClass = async (values: any) => {
    try {
      setAddCourseLoading(true);
      setAddCourseError("");

      const teacherCreditsCost = (values?.totalPrice / values?.totalHours).toFixed(2);

      const roomData = {
        title: values?.className,
        isCollective: true,
        classType: "PACK_PREDEFINED",
        teacherId: auth?.user?._id,
        teacherCreditsSpent: values?.totalHours,
        teacherCreditsCost: Number(teacherCreditsCost),
        teacherCreditsExpiry: values?.endDate,
      };

      const response = await ROOMS_SERVICES.createPackRoom(roomData);
      if (response?.statusCode === StatusCode.CREATED) {
        setTempRoom(response?.data);
        setShowAddCourseModal(false);
        refetchRooms();
        message.success("créé avec succès !");
        addCourseForm.resetFields();
        setShowAddClasse(false);
        setTimeout(() => {
          setIsModalSuccessAddCours(true);
          setCode(response.data);
        }, 1500);
      } else {
        setAddCourseError(response?.message || "Erreur serveur");
      }
    } catch (error: any) {
      setAddCourseError(error?.message || "error");
      message.error(error?.message || "error");
    } finally {
      setAddCourseLoading(false);
    }
  };

  const joinOrganismClass = useCallback(async (code: string, token: string) => {
    try {
      if (code && auth?.user?._id) {
        setLoading(true);
        const response = await TeacherJoinOrganismClass(code, auth?.user?._id, token);
        if (response.statusCode === StatusCode.CREATED) {
          const classData = response?.data;
          setOrganismClassDrawer(false);
          AppNotification(
            "Tu as rejoint la classe avec succès !",
            "AlbertVeryHappy"
          );
          localStorage.setItem("organismClassCode", "");
          localStorage.setItem("organismToken", "");
          localStorage.setItem("userType", "");
          refetch();
          refetchOrganismRooms();
          navigate(`${appRoutes.TEACHER_ROOMS}/${classData?._id}`);
        }
      }
    } catch (error: any) {
      if (error.response.status === 409) {
        message.warning("Vous avez déjà rejoint cette classe !");
      } else if (error.response.status === 404) {
        AppNotification("Le code saisi n'est pas valide", "AlbertSad");
      } else {
        message.error("Une erreur inconnue est survenue");
      }
    }
  }, [organismToken]);

  const joinOrganismClassForm = useCallback(async (values: any) => {
    try {
      if (values?.code && auth?.user?._id) {
        setLoading(true);
        const response = await TeacherJoinOrganismClass(values?.code, auth?.user?._id, organismToken);
        if (response.statusCode === StatusCode.CREATED) {
          const classData = response?.data;
          setOrganismClassDrawer(false);
          AppNotification(
            "Tu as rejoint la classe avec succès !",
            "AlbertVeryHappy"
          );
          localStorage.setItem("organismClassCode", "");
          localStorage.setItem("organismToken", "");
          localStorage.setItem("userType", "");
          refetch();
          refetchOrganismRooms();
          navigate(`${appRoutes.TEACHER_ROOMS}/${classData?._id}`);
        }
      }
    } catch (error: any) {
      if (error.response.status === 409) {
        message.warning("Vous avez déjà rejoint cette classe !");
      } else if (error.response.status === 404) {
        AppNotification("Le code saisi n'est pas valide", "AlbertSad");
      } else {
        message.error("Une erreur inconnue est survenue");
      }
    }
  }, [organismToken]);

  const hide = () => setVisibleSocialMedia(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [isXsScreen, setIsXsScreen] = useState(window.innerWidth > 767 && window.innerWidth <= 1151);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 1151 && window.innerWidth <= 1321);
  const [isMediumScreen, setIsMediumScreen] = useState(window.innerWidth > 1321 && window.innerWidth <= 1606);
  const [isNormalScreen, setIsNormalScreen] = useState(window.innerWidth > 1606 && window.innerWidth <= 1799);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
    setIsXsScreen(window.innerWidth > 767 && window.innerWidth <= 1151);
    setIsSmallScreen(window.innerWidth > 1151 && window.innerWidth <= 1321);
    setIsMediumScreen(window.innerWidth > 1321 && window.innerWidth <= 1606);
    setIsNormalScreen(window.innerWidth > 1606 && window.innerWidth <= 1799);
  };
  window.addEventListener('resize', handleResize);

  const handleSeeClass = (id: string) => {
    navigate(`${appRoutes.TEACHER_ROOMS}/${id}`);
  }

  const OnSelectLevel = useCallback(
    async (levelId: string) => {
      setIsloadingTopic(true);
      try {
        const response = await TOPICS_SERVICES.findAll(levelId);
        if (response?.statusCode === StatusCode.OK) {
          setTempTopic(response?.data);
        }
      } catch (error) {
      } finally {
        setIsloadingTopic(false);
      }
    },
    [tempTopic]
  );

  const filterCourses = useCallback(
    async (values: any) => {
      ///
    },
    [values]
  );

  const onReset = () => {
    form.resetFields();
    filterCourses({
      title: "",
      levelId: "",
      topicId: "",
      status: "",
      self: false,
    });
  };

  const handleFilterClasses = (value: string) => {
    setFilterClasses(value);

    if (!value) {
      setFilteredClasses(roomsData?.data);
      return;
    }

    let filtered = roomsData?.data;

    if (value === "open") {
      filtered = roomsData?.data.filter(
        (room: any) =>
          room.classType &&
          room.classType === "OPEN"
      );
    }

    if (value === "pack") {
      filtered = roomsData?.data.filter(
        (room: any) =>
          room.classType &&
          room.classType === "PACK_PREDEFINED"
      );
    }

    if (value === "organism") {
      filtered = roomsData?.data.filter(
        (room: any) =>
          room.organism
      );
    }

    setFilteredClasses(filtered);
  };

  const handleArchiveClass = async (classeId: string) => {
    try {
      setIsDataLoading(true);
      const response = await ROOMS_SERVICES.archiveClassroom(classeId);
      if (response?.statusCode === StatusCode.CREATED) {
        message.success("Classe archivée avec succès.");
        refetch();
      }
    } catch (error: any) {
      console.log(error);
      message.warning("Erreur survenue lors de l'archivage, merci de réessayer.");
    } finally {
      setIsDataLoading(false);
    }
  }

  const handleDeleteClass = async (classeId: string) => {
    try {
      setIsDataLoading(true);
      const response = await ROOMS_SERVICES.deleteClassroom(classeId);
      if (response?.statusCode === StatusCode.OK) {
        message.success("Classe supprimée avec succès.");
        refetch();
      }
    } catch (error: any) {
      console.log(error);
      message.warning("Erreur survenue lors de la suppression, merci de réessayer.");
    } finally {
      setIsDataLoading(false);
    }
  }

  //!EFFECTS
  /* useEffect(() => {
    fetchCourses(auth.user?._id);
  }, [auth.user?._id, fetchCourses]); */

  useEffect(() => {
    if (roomsData) {
      console.log(roomsData);
      setFilteredClasses(roomsData?.data);
    }
  }, [roomsData]);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (data?.data) {
      const sortedCourses = [...data.data].sort(
        (a: any, b: any) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
      );

      const groupedByDate = sortedCourses.reduce((acc: any, course: any) => {
        const date = new Date(course.startDate).toISOString().split("T")[0];
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(course);
        return acc;
      }, {});

      setCourses(groupedByDate);
    }
  }, [data]);

  useEffect(() => {
    if (adHistorique?.data) {
      const sortedCourses = [...adHistorique.data].sort(
        (a: any, b: any) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
      );

      const groupedByDate = sortedCourses.reduce((acc: any, course: any) => {
        const date = new Date(course.startDate).toISOString().split("T")[0];
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(course);
        return acc;
      }, {});

      setCoursesHistory(groupedByDate);
    }
  }, [adHistorique]);

  useEffect(() => {
    if (checkClass) {
      setCurrentTab("2");
      setTimeout(() => {
        dispatch(setCheckClass(false));
      }, 2000);
    }
  }, [checkClass]);

  useEffect(() => {
    if (checkClassOrganism) {
      setCurrentTab("3");
      setTimeout(() => {
        dispatch(setCheckClassOrganism(false));
      }, 2000);
    }
  }, [checkClass]);

  useEffect(() => {
    if (auth?.user) {
      const organismClassCode = localStorage.getItem("organismClassCode");
      const organismToken = localStorage.getItem("organismToken");
      const userType = localStorage.getItem("userType");
      if (organismToken && organismClassCode && userType) {
        setCurrentTab("3");
        setOrganismToken(organismToken);
        setOrganismClassCode(organismClassCode);
        showOrganismClassDrawer();
        joinOrganismClass(organismClassCode, organismToken);
      }
    }
  }, [auth]);

  return (
    <div style={{ marginTop: isMobile ? (!userHavingCalendar || userTeachingOrganismClass) ? "110px" : "70px" : "0px" }}>
      {!isMobile && <Breadcrumbs isRooms={true} />}
      <AppScreen>
        {!isMobile && <img src={EllipseTeacherProfileFour} height={106} style={{ position: "absolute", top: "25%", left: "0px", zIndex: "-1" }}></img>}
        {!isMobile && <img src={EllipseTeacherProfileFive} height={54} style={{ position: "absolute", top: "35%", left: "94%", zIndex: "-1" }}></img>}
        <div style={{ marginBottom: "80px" }}>

          <div className="header-container" style={{ padding: "24px 0px 24px 0px" }}>
            <Space align="center" size="middle">
              <div className="icon-wrapper" style={{ background: "#fff2e0" }}>
                <img src={CLassroomIcon} height={30} />
              </div>
              <Title level={4} style={{ margin: 0 }}>
                Mes classes
              </Title>
              <HelpPopover id={"classe"} />

              <Select
                value={filterClasses}
                onChange={(value) => handleFilterClasses(value)}
                allowClear
                className="view-select-filter"
                placeholder={"Filtrer"}
              >
                <Option value="open">Classes ouvertes</Option>
                <Option value="pack">Packs prédéfinis</Option>
                <Option value="organism">Classe avec un organisme</Option>
              </Select>
            </Space>

            <Button
              type="primary"
              size="middle"
              onClick={() => setShowAddClasse(!showAddClasse)}
              className="classBtn classBtn-teal"
            >
              Créer une classe
            </Button>
          </div>

          <div className={s.classesBox}>
            <div style={{ marginTop: "30px", overflowY: "scroll", scrollbarWidth: "thin", height: "640px" }}>
              {loadingRooms && (
                <React.Fragment>
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                </React.Fragment>
              )}

              {!loadingRooms && (
                <Fragment>
                  {!isError ? (
                    <Flex>
                      {/* <CardAddCours
                        onClick={() => setShowAddClasse(!showAddClasse)}
                      /> */}
                      <Fragment>
                        {filteredClasses?.map((classroom: any) => (
                          <CardClasses classroom={classroom} onArchiveClass={() => handleArchiveClass(classroom?._id)} onDeleteClass={() => handleDeleteClass(classroom?._id)} isLoading={isDataLoading} />
                        ))}
                      </Fragment>
                    </Flex>
                  ) : (
                    <AppResult title="Une erreur est survenue !" status="404" />
                  )}
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </AppScreen>

      {/* Drawer add Cours */}
      <Drawer
        className="drawer"
        onClose={() => setShowAddCourseModal(!showAddCourseModal)}
        visible={showAddCourseModal}
        width={isMobile ? "100%" : isXsScreen ? "100%" : isSmallScreen ? "100%" : isMediumScreen ? "97%" : isNormalScreen ? "92%" : "70%"}
        title={<div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent" }}>Historique des cours</div>}
        headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
        closeIcon={
          <img
            src={ArrowBack}
            height={isMobile ? 10 : 18}
            style={{}}
          ></img>
        }
        drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "50px", borderBottomLeftRadius: isMobile ? "0px" : "50px", boxShadow: "-3px 3px 34px #39393929" }}
      >
        <div className={styles.__first_drawer}>
          <div className={styles.drawer__content}>

            {adHistoriqueLoading ? (
              <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
              </>
            ) : (
              <>
                {!adHistoriqueLoading && adHistorique?.data.length <= 0 ? (
                  <AppResult
                    status={"info"}
                    title="Tu n’as aucune réservation"
                  />
                ) : (
                  <div className={s.historyBox}>
                    {coursesHistory && Object.keys(coursesHistory)?.map((date) => {
                      return (
                        <>
                          <div key={date} style={{ marginTop: "10px" }}>
                            <div className={s.dateBox}>
                              {new Intl.DateTimeFormat("fr-FR", {
                                weekday: "long",
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                              }).format(new Date(date))}
                              {isToday(date) && <div className={s.todayBox}>Aujourd’hui</div>}
                              <div className={s.horizontalLine}></div>
                            </div>
                            {!isMobile && coursesHistory[date].map((course: any) => (
                              <div key={course.id}>
                                <CoursesRoom course={course} />
                              </div>
                            ))}

                            {isMobile && <div className={s.cardDisplay} /* className={`${s.cardDisplay} ${courses[date].length === 1 ? s.singleCourse : ""}`} */>
                              {coursesHistory[date].map((course: any) => (
                                <div key={course.id}>
                                  <CoursesRoom course={course} />
                                </div>
                              ))}
                            </div>}
                          </div>
                        </>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </Drawer>

      {/* Drawer Add Rooms */}
      <AddRoom
        addCourse={addCourse}
        addCourseLoading={addCourseLoading}
        showAddClasse={showAddClasse}
        setShowAddClasse={setShowAddClasse}
        addCourseForm={addCourseForm}
        addOpenClass={addOpenClass}
        addPackClass={addPackClass}
      />

      {/* Modal add cours */}
      <Modal
        title={null}
        closable={false}
        centered
        visible={isModalSuccessAddCours}
        onCancel={() => setIsModalSuccessAddCours(false)}
        footer={null}
        width={800}
      >
        <div className={styles.__success__modal_container}>
          <div className={styles.modal__card}>
            <h3 className={styles.modal__card__title}>
              Classe de {tempRoom?.title}
            </h3>
            <Matiers
              level={tempRoom?.level?.title}
              cours={tempRoom?.course?.title}
              className={styles.__matier}
              classNameIcon={styles.__icon_matiere}
            />
            <div className={styles.__modal__img__success}>
              <Image preview={false} src={Success} width={100} />
            </div>

            <span className={styles.__code__access__title}>
              Code d’accès{" "}
            </span>

            <div className={styles.__code}>
              <span>
                {tempRoom?.accessCode}
              </span>
            </div>

            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
              <div>
                <CopyToClipboard
                  text={tempRoom?.accessCode}
                  onCopy={() =>
                    message.success({
                      content: "copié dans le presse-papiers",
                    })
                  }
                >
                  <AppButton className={styles.__btn}>Copier</AppButton>
                </CopyToClipboard>{" "}
              </div>
              <div>
                <Popover
                  content={
                    <>
                      <div>
                        {" "}
                        <SOCIAL_SHARING
                          prefix={MESSAGE_PREFIX_PARTAGE_RESEAUX_SOCIAUX}
                          codeAcces={tempRoom?.accessCode}
                          createdClassName={tempRoom?.title}
                          userLastname={auth?.user?.lastname}
                          userFirstname={auth?.user?.firstname}
                        />
                      </div>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            hide();
                          }}
                          href="/"
                        >
                          Fermer
                        </a>
                      </div>
                    </>
                  }
                  trigger="click"
                  visible={visibleSocialMedia}
                  onVisibleChange={handleVisibleChange}
                >
                  {" "}
                  <AppButton className={styles.__btn}>partager</AppButton>
                </Popover>{" "}
              </div>
            </div>
          </div>

          <div
            className={styles.close}
            onClick={() => setIsModalSuccessAddCours(false)}
          >
            <Image preview={false} src={Close} width={25} />
          </div>
        </div>
      </Modal>

      {/* Drawer Join Class */}
      <AppDrawer
        title={false}
        width={"60%"}
        onClose={onCloseOrganismClassDrawer}
        visible={organismClassDrawer}
      >
        <div className={stl.__drawer__body}>
          <H1>Rejoindre une classe</H1>

          <p>
            Pour devenir le professeur de cette classe, entre le code reçu par email. Une fois le code validé, tu pourras donner des cours aux élèves de cette classe.
          </p>

          <Formik
            initialValues={{
              code: organismClassCode ? organismClassCode : "",
            }}
            validationSchema={TeacherJoinClassSchema}
            onSubmit={joinOrganismClassForm}
          >
            {({ errors, touched }) => (
              <FormikForm style={{ position: "relative" }}>
                <div className={stl.__join__class}>
                  <Field
                    name="code"
                    type="text"
                    placeholder="Insérer le code de la classe "
                  />
                  <Image
                    src={Key}
                    preview={false}
                    width={15}
                    onClick={onCloseOrganismClassDrawer}
                    className={stl.__key}
                  />
                </div>
                {errors.code && touched.code ? (
                  <div className={stl.__error}>
                    <span>{errors.code}</span>
                  </div>
                ) : null}

                <div className={stl.joinClassButtonBox}>
                  <AppButton
                    loading={loading}
                    htmlTypeSubmit={true}
                    className={stl.meetButton}
                  >
                    Rejoindre la classe
                  </AppButton>
                </div>

              </FormikForm>
            )}
          </Formik>
        </div>
      </AppDrawer>
    </div>
  );
};

export default Rooms;
